module.exports = __webpack_public_path__ + "static/media/ghost-smile.91524cc1.svg";